import { StockTypeCoin } from '@/enum';

export const F_STOCK_TYPE_COIN = stockType => {
    return StockTypeCoin[stockType];
};

export function THOUSANDTHS(num) {
    if (num === 0) return 0;
    else if (!num) return;

    let tempNum;
    if (typeof num === 'number') num = num.toString();
    const tempArr = num.split('.');
    tempNum = tempArr[0];
    if (tempNum && typeof tempNum !== 'number') {
        tempNum = Number(tempNum);
    }
    const res = `${tempNum.toLocaleString('en-US')}${tempArr[1] ? `.${tempArr[1]}` : ''}`;
    return res;
}

export function FORMAT_TIME(val) {
    return val.slice(0, 5) + val.slice(10, 16);
}
